import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a93f39f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "icon"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "|", -1));
const _hoisted_6 = {
  class: "dropdown"
};
const _hoisted_7 = {
  class: "el-dropdown-link"
};
const _hoisted_8 = {
  class: "breadcrumbs"
};
const _hoisted_9 = {
  class: "wrapper"
};
import { ref, onMounted } from 'vue';
import breadcrumb from './breadcrumb.vue';
import Tabs from './Tabs.vue';
import dayjs from 'dayjs';
import store from '@/store';
import { useRouter } from 'vue-router';
import Cookies from 'js-cookie';
export default {
  __name: 'Content',
  props: ['isClose'],
  emits: ['change'],
  setup(__props, {
    emit: __emit
  }) {
    const userSerializer = JSON.parse(sessionStorage.getItem('userSerializer')) || [];
    // 从父组件接收 isClose 属性
    const props = __props;
    // 定义时间
    let time = ref(null);
    // 切换菜单折叠
    const change = __emit;
    const emitChange = () => {
      // 使用从父组件接收的 isClose
      change('change', !props.isClose);
    };
    // 生命周期函数
    onMounted(() => {
      // 获取当前时间
      time.value = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      // 定时器
      setInterval(() => {
        time.value = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      }, 1000);
    });
    // 定义路由
    const router = useRouter();
    // 退出登录并重定向到登录页面
    const out = () => {
      console.log('开始退出登录');
      // 清除所有页面状态
      store.commit('CLEAR_ITEM_LIST_STATE');
      store.commit('CLEAR_STORE_LIST_STATE');
      store.commit('CLEAR_ORDER_LIST_STATE');
      store.commit('CLEAR_USER_LIST_STATE');
      // ... 清除其他页面状态

      // 清除所有存储的数据
      window.sessionStorage.clear();
      window.localStorage.clear();
      Cookies.remove('token');
      Cookies.remove('user_name');
      Cookies.remove('password');
      Cookies.remove('rememberMe');
      store.commit('RESET_TAB');
      store.commit("SET_ROUTES_STATE", false);
      store.dispatch('resetCachedView');
      console.log('数据已清除，准备跳转到登录页');
      // 使用push而不是replace，允许用户返回（虽然数据已清除）
      // 或者使用location.href确保完全跳转
      try {
        router.push('/login').then(() => {
          console.log('已跳转到登录页');
        }).catch(error => {
          console.error('router跳转失败，使用location.href:', error);
          window.location.href = '/login';
        });
      } catch (error) {
        console.error('退出登录跳转失败:', error);
        window.location.href = '/login';
      }
    };
    const logout = () => {
      // 清除所有页面状态
      store.dispatch('clearPageState', 'orderList');
      store.dispatch('clearPageState', 'itemList');
      store.dispatch('clearPageState', 'storeList');
      // ... 其他清理工作
    };
    return (_ctx, _cache) => {
      const _component_Expand = _resolveComponent("Expand");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Fold = _resolveComponent("Fold");
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_SwitchButton = _resolveComponent("SwitchButton");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.isClose ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        onClick: emitChange
      }, {
        default: _withCtx(() => [_createVNode(_component_Expand)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        onClick: emitChange
      }, {
        default: _withCtx(() => [_createVNode(_component_Fold)]),
        _: 1
      })), _createVNode(breadcrumb)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(time)), 1), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createVNode(_component_router_link, {
              to: {
                name: '个人中心'
              }
            }, {
              default: _withCtx(() => [_createTextVNode("个人中心")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "loginout",
              onClick: out
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_SwitchButton)]),
              _: 1
            }), _createTextVNode("安全退出")])]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createTextVNode("   " + _toDisplayString(_unref(userSerializer).name) + " ", 1), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_8, [_createVNode(Tabs)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_view)])], 64);
    };
  }
};